import { Middleware } from 'redux';
import { notAuthorized } from '../modules/Auth';
import { State } from '../types/State';
import { Dispatch } from '../types/Store';

// eslint-disable-next-line unicorn/consistent-function-scoping
const autoLogoutMiddleware: Middleware<{}, State, Dispatch> = () => (next) => (action) => {
  if ('payload' in action && action.payload != null) {
    if (action.payload.status === 401) {
      return next(notAuthorized());
    }
  }
  return next(action);
};

export default autoLogoutMiddleware;
